import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Download from "./components/Download";
import Membership from "./components/Membership";
import Recharge from "./components/Recharge";
import Support from "./components/Support";
import Reputation from "./components/Reputation";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Download />
        <Membership />
        <Recharge />
        <Support />
        <Reputation />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}